import { Button } from "@mui/material";
import React from "react";

import { SecondaryButton } from "./button";
import filterIcon from "../assets/button/filterNotApplied.svg";

const FilterByButton = ({
  toggleDrawer = () => {},
  varientType = "text",
  text = "Filter By",
  endIcon = "",
}) => {
  return (
    <SecondaryButton
      // variant={varientType}
      // sx={buttonStyle}
      startIcon={<img src={filterIcon} alt="filterIcon" />}
      onClick={toggleDrawer("right", true)}
    >
      {text}
    </SecondaryButton>
  );
};

export const SortByButton = ({
  toggleDrawer = () => {},
  varientType = "text",
  text = "Sort By",
  endIcon = "",
}) => {
  //css
  const buttonStyle = {
    width: "auto",
    border: "1px solid rgba(0, 0, 0, 0.30)",
    borderRadius: "12px",
    height: "45px",
    fontSize: "15px",
    fontFamily: "Proxima Nova",
    color: "#000",
    fontWeight: 600,
    padding: "0px 15px",
    backgroundColor: "#fff",
    lineHeight: "normal",
  };

  return (
    <SecondaryButton
      // variant={varientType}
      // sx={buttonStyle}
      startIcon={<img src={filterIcon} alt="filterIcon" />}
      onClick={toggleDrawer("right", true)}
    >
      {text}
    </SecondaryButton>
  );
};

export default FilterByButton;
